import React from 'react';
import { Candidate } from '@/components/candidates/types';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CandidateEmploymentCard } from './CandidateEmploymentCard';
import { JobPreferences } from './JobPreferences';
import { Briefcase, Target } from 'lucide-react';

interface EmploymentAndPreferencesProps {
  candidate: Candidate;
}

export const EmploymentAndPreferences: React.FC<EmploymentAndPreferencesProps> = ({ candidate }) => {
  return (
    <div className="space-y-6">
      {/* Employment History Section */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Briefcase className="h-5 w-5" />
            Employment History
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CandidateEmploymentCard candidate={candidate} />
        </CardContent>
      </Card>

      {/* Job Preferences Section */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Target className="h-5 w-5" />
            Job Preferences & Career Goals
          </CardTitle>
        </CardHeader>
        <CardContent>
          <JobPreferences candidate={candidate} />
        </CardContent>
      </Card>
    </div>
  );
};